////////////////////////////////////////////////////
//                                                //
//  ENDPOINT -> pedidos/?loja=                    //
//                                                //
//  PÁGINA EXCLUSIVA PARA FRANQUEADOS PARA        //
//  VISUALIZAR OS PEDIDOS ANTERIORES DE CLIENTES. //
//                                                //
//  RECEBE COMO PARÂMETRO NA URL O ID             //
//  DA LOJA QUE ESTÁ VENDENDO OS PRODUTOS.        //
//                                                //
////////////////////////////////////////////////////  



import React, {useState} from "react"

import ContinuarComprando from  '../components/continuar_comprando';
import PrecoPictureQuantidadeFranqueado from  '../components/preco_picture_quantidade_franqueado';

import api from "../services/api";


function Pedidos() {
  
  // ESTADOS DEFINIDOS
    // 'pedidos' = LISTA DE PEDIDOS DO CLIENTE  

  let [pedidos, setPedidos] = useState([[]])


  if(!sessionStorage['login']){  // CASO NÃO ESTIVER LOGADO
    window.location.href = '/?id='+ sessionStorage['loja']  // REDIRECIONA DE VOLTA PARA A HOME     
  }    

  window.onload = async function() {
    // FUNÇÃO CHAMADA NO CARREGAMENTO DESTA PÁGINA ('/pedidos/loja=')

    if(sessionStorage['login'].includes('/')){  // VERIFICA SE O USUÁRIO ESTÁ LOGADO COMO FRANQUEADO

      var params = window.location.search 
      var urlparams = new URLSearchParams(params)
      var loja = urlparams.get('loja')
      
      if(loja != sessionStorage['loja']){  // VERIFICA SE A LOJA DA URL É A MESMA LOJA DA SESSION
        window.location.href = '/pedidos/?loja='+ sessionStorage['loja']  // CASO NÃO SEJA, REDIRECIONA PARA A PÁGINA DA LOJA DA SESSION      
      }
      
      var login = await api.post('verificar_login',{  // VERIFICA NO DB SE A LOJA CORRESPONDE AO TOKEN E TAMBÉM BUSCA O VALOR DO ESTOQUE DE SEGURANÇA DA LOJA
        "id_loja": sessionStorage['loja'],
        "login": sessionStorage['login']
      }).then((response) => {
        return response
      })    
      // login['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
        // 'login' ->  BOOLEANO QUE DEFINE SE O USUÁRIO PODE PERMANECER NA PÁGINA

        // 'id' -> STRING COM O ID DO USUÁRIO CORRETO
          // ISSO OCORRE CASO 'login' SEJA FALSO PORQUE OS TOKENS DE LOGIN SAO INCOMPATÍVEIS
          // CASO 'login' SEJA FALSO E O TERMO 'id' NÃO ESTEJA NO DICIONÁRIO, O USUÁRIO NÃO FOI ENCONTRADO NO DB
      
        // 'estoque_seguranca' -> INT COM O VALOR DO ESTOQUE DE SEGURANÇA QUE ESTÁ SALVO NO DB
          // ESSE VALOR APARECE NO DICIONÁRIO APENAS SE LOGIN FOR TRUE      
      
      if(!login['data']['login']){  // SE NÃO CORRESPONDER
        sessionStorage['loja'] = login['data']['id']  // TROCA A LOJA DA SESSION
        window.location.href = '/pedidos/?loja='+ login['data']['id']  // E REDIRECIONA PARA A PÁGINA DA LOJA CORRETA
      } 

    }
    else{  // CASO O USUÁRIO NÃO ESTEJA LOGADO COMO FRANQUEADO
      if(window.location.pathname != '/pedidos'){
        window.location.href = '/?id=' + sessionStorage['loja']  // REDIRECIONA DE VOLTA PARA A HOME
      }
    }

    search_pedidos()  // CHAMA A FUNÇÃO DE BUSCAR OS PEDIDOS
  }

  async function search_pedidos(){  // FUNÇÃO QUE BUSCA OS PEDIDOS
    // FUNÇÃO CHAMADA NO ONLOAD DESTA PÁGINA

    var id_loja = sessionStorage['loja']  // DEFINE A LOJA
    var query_start = 0  // INICIA A SUBQUERY EM ZERO
    var query_end = 1  // E REALIZA A BUSCA EM SUQUERIES DE 1 PEDIDO

    var produtos_novo = []

    var break_bool = false  // BOOLEANO DEFINIRÁ QUANDO NÃO EXISTIREM MAIS SUBQUERIES
    while(!break_bool){

      var resp = await api.post('buscar_pedidos_loja',{  // BUSCA NO DB OS PEDIDOS DA LOJA
        "id_loja": id_loja,
        "query_start": query_start,
        "query_end": query_end,
      }).then((response) => {
        return response
      })
      // resp['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
        // 'data' -> LISTA COM 3 POSIÇÕES
          // 1a POSIÇÃO -> STRING COM O NOME DO CLIENTE
          // 2a POSIÇÃO -> STRING COM ID DO PEDIDO
          // 3a POSIÇÃO -> DATA DO PEDIDO
            
        // 'produtos' -> LISTA COM OS PRODUTOS DO PEDIDO
          // CADA ITEM DA LISTA É UMA LISTA COM 3 POSIÇÕES
          // 1a POSIÇÃO -> STRING COM A DESCRIÇÃO DO PRODUTO
          // 2a POSIÇÃO -> STRING COM A URL DA PRIMEIRA IMAGEM DO PRODUTO
          // 3a POSIÇÃO -> STRING COM O VALOR DA QUANTIDADE DE ITENS COMPRADOS DAQUELE PRODUTO

      // 'query_end' -> INT COM O VALOR DA POSIÇÃO DO FINAL DA SUBQUERY         
      
      query_start = (query_start + 1)  // DEFINE O COMEÇO DA PRÓXIMA SUBQUERY  
      query_end = (resp.data.query_end)  // DEFINE O FINAL DA PRÓXIMA SUBQUERY  

      if (!resp.data.data[0]){  // CASO O COMEÇO E FINAL DA SUBQUERY SEJAM IGUAIS
        break_bool = true  // TODOS OS PEDIDOS JÁ FORAM LISTADOS
      }
      
      else{  // CASO CONTRÁRIO
        var matriz = [resp.data.data, resp.data.produtos]  // JUNTA AS INFORMAÇÕES NOVAS COM AS ANTIGAS
        produtos_novo = produtos_novo.concat([matriz])
      }

      setPedidos(produtos_novo)  // DEFINE O ESTADO COM AS INFORMAÇÕES NOVAS
    }  
  }  

  function show_confirm(id_pedido){  // FUNÇÃO PARA APARECER A DIV DE CONFIRMAÇÃO DO CANCELAMENTO
    // FUNÇÃO CHAMADA NO CLICK DO BOTAO 'btn-show-confirm' DESTA PÁGINA

    document.getElementById('cancel-btn' + id_pedido).classList.add('d-none')
    document.getElementById('confirm' + id_pedido).classList.remove('d-none')
  }

  function hide_confirm(id_pedido){// FUNÇÃO PARA SUMIR A DIV DE CONFIRMAÇÃO DO CANCELAMENTO
    // FUNÇÃO CHAMADA NO CLICK DO BOTAO 'btn-shide-confirm' DESTA PÁGINA

    document.getElementById('confirm' + id_pedido).classList.add('d-none')
    document.getElementById('cancel-btn' + id_pedido).classList.remove('d-none')
  }  

  async function cancela_pedido(id_pedido){// FUNÇÃO PARA CANCELAR O PEDIDO SELECIONADO
    // FUNÇÃO CHAMADA NO CLICK DO BOTAO 'btn-cancela-este-pedido' DESTA PÁGINA

    var login = await api.post('cancela_pedido',{  // INSERE NO DB O CANCELAMENTO DO PEDIDO
      "pedido": id_pedido,
    }).then((response) => {
      return response
    })   
    // 'login' NÃO RETORNA NADA

    document.getElementById('card' + id_pedido).classList.add('d-none')
  }

  // CASO EXISTAM PRODUTOS
  if(pedidos[1]){  // RENDERIZA A PÁGINA

    // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
      // 'ContinuarComprando' -> VERSÃO DO HEADER QUE NÃO APARECE A BARRA DE PESQUISA E SIM BOTÃO DE VOLTAR PARA A PÁGINA HOME
      // 'PrecoPictureQuantidadeFranqueado' -> CARD COM DESCRIÇÃO, QUANTIDADE E FOTO DE CADA PRODUTO    

      return (
        <div>
          <div>
            <ContinuarComprando />
          </div>

          <div id="todos_os_produtos" class="custom-container mt-5 pt-5">
            <div class='mb-5'>
              {pedidos.map((block) => (

                <div class='my-3 mx-0 card-login p-2 w-100 border-gray' id={"card" + block[0][0][1]}>
                  <div class="montserrat verde bold">Pedido:</div>
                  <div class="montserrat mb-1">{block[0][0][1]}</div>

                  <div class="montserrat verde bold">Cliente:</div>
                  <div class="montserrat mb-1">{block[0][0][0]}</div>

                  <div class="montserrat verde bold">Data:</div>
                  <div class="montserrat mb-1">{block[0][0][2]}</div>

                  <div class="montserrat verde bold">Produtos:</div>
                  <div class="d-flex flex-wrap justify-content-start mx-3 mt-3 px-0 pt-0 start-page custom-container-catalogo align-items-end">

                  {block[1].map((produto) => (
                    <div class="">
                      <PrecoPictureQuantidadeFranqueado dsc={produto[0]} img={produto[1]} qnt={produto[2]} />
                    </div>
                  ))}            
                  </div>

                  <div id={'cancel-btn'+block[0][0][1]} class="mb-3 d-flex flex-wrap justify-content-end">
                    <button id='btn-show-confirm' onClick={() => show_confirm((block[0][0][1]))} class="cancel px-3 py-1"><i class='fa fa-times montserrat pr-4 py-1'></i>Cancelar</button>
                  </div>

                  <div class="montserrat col col-12 row mx-0 d-none mb-3" id={'confirm'+block[0][0][1]}>
                    <div class='col-8'>
                      Confirmar Cancelamento?
                    </div>
                    <div class='col-2 d-flex flex-wrap justify-content-end'>
                      <button id='btn-cancela-este-pedido' onClick={() => cancela_pedido(block[0][0][1])} class="btn-verde-pqn p-0"><i class='fa fa-check montserrat my-1'></i></button>
                    </div>
                    <div class='col-2 d-flex flex-wrap justify-content-end'>
                      <button id='btn-hide-confirm' onClick={() => hide_confirm(block[0][0][1])} class="cancel-pqn p-0"><i class='fa fa-times montserrat my-1'></i></button>
                    </div>
                  </div>

                </div>
              ))}            
            </div>
          </div>
        </div>    
      )
  }

  // CASO CONTRÁRIO RENDERIZA APENAS A VERSÃO DO HEADER QUE NÃO APARECE A BARRA DE PESQUISA E SIM BOTÃO DE VOLTAR PARA A PÁGINA HOME
  return(
    <div>
      <ContinuarComprando />
    </div>
  )
}


export default Pedidos;